import { memo } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

function ProspectEmailAddressForm({ prospectEmail, changeValue }) {
  return (
    <>
      <Col md={2} className="bo-same-line">
        <Form.Label>Email address:</Form.Label>
      </Col>
      <Col md={4} className="bo-same-line">
        <Form.Control
          className="bo-input"
          type="text"
          name="email"
          id="email"
          placeholder="Email address"
          value={prospectEmail || ''}
          onChange={changeValue}
        />
      </Col>
    </>
  );
}

export default memo(ProspectEmailAddressForm);
